import Vue from "vue"
import authservice from "../../configurations/authentications/auth"

const Auth = new authservice()


export const sessionComplete = () => Vue.swal({
    title: "Session Expired",
    text: "Your session has expired, please logIn again!",
    type: "info"
}).then(function () {   
    Auth.logout();
})


// WEBPACK FOOTER //
// ./src/configurations/session/sessioncomplete.js